import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import {__} from "~/ts/library/Translate";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import {useRawComponent} from "~/core-ui/ts/useRawComponent";
import SideMenuTargetReasonsTooltip
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuTargetReasonsTooltip.vue";


const __default__ = {
    name: "SideMenuTargetReasons"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    canEdit: { type: Boolean },
    removeTargetReason: { type: Function }
  },
  setup(__props: any) {

let props = __props;

async function removeTargetReason(reason: OperatorApplicationApi.OperatorApplicationClientTargetReasonOpenApiModel) {
    if (props.canEdit && props.removeTargetReason) {
        try {
            await ElConfirm(__("Вы уверены, что хотите удалить это поле?"));
            let p: OperatorApplicationApi.RemoveTargetClientReasonOpenApiModel = {
                username: props.userdata.username,
                reason: reason.reason
            }
            props.removeTargetReason(p);
        } catch (e) {

        }
    }
}


return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.userdata.targetReasons, (reason, key) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: key,
        class: "text-truncate"
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(__props.canEdit ? 'a' : 'span'), {
          class: _normalizeClass({
                    'cursor-pointer': __props.canEdit
                }),
          onClick: ($event: any) => (removeTargetReason(reason))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(reason.reason), 1)
          ]),
          _: 2
        }, 1032, ["class", "onClick"]))
      ])), [
        [_directive_my_tooltip, __props.canEdit ? {component: _unref(useRawComponent)(SideMenuTargetReasonsTooltip), props: {reason}, placement:'left'} : null]
      ])
    }), 128))
  ]))
}
}

})